export const PATH_REPRODUCTION = "/reproduction";
export const KEY_REPRODUCTION = "reproduction";
export const TITLE_REPRODUCTION = "Reproduction";

export const PATH_REPRODUCTION_LOT_INTRANT = `${PATH_REPRODUCTION}/lot-intrant`;
export const KEY_REPRODUCTION_LOT_INTRANT = `${KEY_REPRODUCTION}/lot-intrant`;
export const TITLE_REPRODUCTION_LOT_INTRANT = "Liste des Lots d'intrants";

export const PATH_REPRODUCTION_SEMENCE = `${PATH_REPRODUCTION}/semence`;
export const KEY_REPRODUCTION_SEMENCE = `${KEY_REPRODUCTION}/semence`;
export const TITLE_REPRODUCTION_SEMENCE = "Liste des semences";

export const PATH_REPRODUCTION_INSEMINATION = `${PATH_REPRODUCTION}/insemination`;
export const KEY_REPRODUCTION_INSEMINATION = `${KEY_REPRODUCTION}/insemination`;
export const TITLE_REPRODUCTION_INSEMINATION = "Liste des inseminations";

export const PATH_REPRODUCTION_MISE_BAS = `${PATH_REPRODUCTION}/mise-bas`;
export const KEY_REPRODUCTION_MISE_BAS = `${KEY_REPRODUCTION}/mise-bas`;
export const TITLE_REPRODUCTION_MISE_BAS = "Liste des Mises Bas";

export const PATH_REPRODUCTION_PRODUIT = `${PATH_REPRODUCTION}/produit`;
export const KEY_REPRODUCTION_PRODUIT = `${KEY_REPRODUCTION}/produit`;
export const TITLE_REPRODUCTION_PRODUIT = "Liste des Produits";
